export default __webpack_public_path__ + "static/7_29-dcc0367806294428676f78c466507221.png";